<div class="app-container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="app-toolbar">
    <div class="app-toolbar-sections">
      <!-- Start: Hamburger + Title -->
      <div class="app-toolbar-start">
        <button mat-icon-button (click)="mainSideNav.toggle()"><mat-icon>menu</mat-icon></button>
        <span class="app-toolbar-title" i18n="@@Administration">Administration</span>
      </div>

      <!-- End -->
      <div class="app-toolbar-end">
        <app-shopping-cart-top-bar-button></app-shopping-cart-top-bar-button>
        <app-active-role></app-active-role>
      </div>
    </div>
  </mat-toolbar>

  <mat-sidenav-container class="app-sidenav-container" (backdropClick)="mainSideNav.close()" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav opened #mainSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" (keydown.escape)="mainSideNav.close()" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <mat-nav-list>
        <app-side-nav focus="admin"></app-side-nav>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="m2app-dark">
      <mat-card appearance="outlined" class="app-content">
        <mat-card-content>
          <table class="users" *ngIf="users">
            <tr>
              <th i18n="@@Id">Id</th>
              <th i18n="@@Name">Name</th>
              <th i18n="@@Email">Email</th>
              <th i18n="@@Subcription Level">Subcription Level</th>
              <th i18n="@@Subcription Status">Subcription Status</th>
              <th i18n="@@Subcription Period">Subcription Period</th>
              <th i18n="@@Recurring Status">Recurring Status</th>
              <th i18n="@@Start Date">Start Date</th>
              <th i18n="@@Paid Until">Paid Until</th>
              <th></th>
            </tr>
            <ng-container *ngFor="let user of users">
              <tr [class.selected]="user === selectedUser" (click)="selectedUser = user">
                <td>{{user.ID}}</td>
                <td>{{user.name}}</td>
                <td>{{user.email}}</td>
<!--                <ng-container *ngIf="user.subscription">-->
<!--                  <td>{{user.subscription.getSubscriptionLevel()}}</td>-->
<!--                  <td>{{user.subscription.getSubscriptionStatus()}}</td>-->
<!--                  <td>{{user.subscription.getSubscriptionPeriod()}}</td>-->
<!--                  <td>{{user.subscription.getRecurringStatus()}}</td>-->
<!--                  <td>{{user.subscription.startDate}}</td>-->
<!--                  <td>{{user.subscription.paidUntilDate}}</td>-->
<!--                </ng-container>-->
<!--                <ng-container *ngIf="!user.subscription">-->
<!--                  <td></td>-->
<!--                  <td></td>-->
<!--                  <td></td>-->
<!--                  <td></td>-->
<!--                  <td></td>-->
<!--                  <td></td>-->
<!--                </ng-container>-->
                <td>
                  <!-- <button mat-button type="button" (click)="assumeUserIdentity(user.ID)"><mat-icon>supervised_user_circle</mat-icon></button> -->
                </td>
              </tr>
            </ng-container>
          </table>
        </mat-card-content>
      </mat-card>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
